import React, { useEffect, useState } from 'react'
import './TacticalView.scss'

import { Drawer, Button } from '@material-ui/core'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import TacticalDetection from './TacticalDetection/TacticalDetection'
import TacticalInformation from './TacticalInformation/TacticalInformation'
import TacticalMap from './TacticalMap/TacticalMap'
import TacticalTelemetry from './TacticalTelemetry/TacticalTelemetry'
import TacticalVideo from './TacticalVideo/TacticalVideo'

import { getUsecaseById } from '../../services/usecase.service'
import allActions from '../../redux/actions'
import { getLatestActiveSessionId } from '../../services/mission.service'
import { AppState } from 'src/redux/store'
import { Usecase } from 'src/redux/reducers/types'

function TacticalView() {
    const { state } = useLocation()
    const [usecase, setUsecase] = useState<null | Usecase>(null)
    const [isUsecaseLoaded, setUsecaseLoaded] = useState(false)
    const [errorMessage, setErrorMessage] = useState('General Error')
    const [iserrorPresent, setError] = useState(false)
    const [selectedFromList, setSelectedFromList] = useState()
    const [detectionSelectedFromList, setDetectionSelectedFromList] = useState()
    // REDUX
    const dispatch = useDispatch()
    const drawersState = useSelector((state: AppState) => state.drawers)
    const [activeSessionId, setActiveSessionId] = useState(null)

    // Quick configs to re-enable components if needed
    const showLeftAssetsDrawer = false
    const showTacticalInformation = false

    function toggleAssetsDrawer(event: React.MouseEvent<any>) {
        event.preventDefault()
        drawersState.assetsDrawerState
            ? dispatch(allActions.drawersActions.closeAssetsDrawer())
            : dispatch(allActions.drawersActions.openAssetsDrawer())
    }

    function renderAssetsDrawerIcon() {
        if (drawersState.assetsDrawerState) {
            return <ChevronLeftIcon />
        } else {
            return <ChevronRightIcon />
        }
    }

    function toggleDetectionsDrawer(event: React.MouseEvent<any>) {
        event.preventDefault()
        drawersState.detectionsDrawerState
            ? dispatch(allActions.drawersActions.closeDetectionsDrawer())
            : dispatch(allActions.drawersActions.openDetectionsDrawer())
    }

    function renderDetectionsDrawerIcon() {
        if (drawersState.detectionsDrawerState) {
            return <ChevronRightIcon />
        } else {
            return <ChevronLeftIcon />
        }
    }

    useEffect(() => {
        if (isUsecaseLoaded) {
            return
        } // Load usecase once

        const getUsecase = async () => {
            try {
                if ((state as any).id != null) {
                    const usecase = await getUsecaseById((state as any).id)
                    if (usecase) {
                        setUsecase(usecase)
                        setUsecaseLoaded(true)
                    }
                } else {
                    setError(true)
                    setErrorMessage('Error getting Usecase id from main list component')
                }
            } catch (error) {
                setError(true)
                setErrorMessage('Error Fetching Usecase from API Usecase, try again selecting a usecase from the list')
            }
        }
        getUsecase()

        return () => {
            dispatch(allActions.drawersActions.closeAssetsDrawer())
            dispatch(allActions.drawersActions.closeDetectionsDrawer())
        }
    }, [])

    useEffect(() => {
        const fetchActiveSession = async (usecase_id: number) => {
            const session_id = await getLatestActiveSessionId(usecase_id)
            setActiveSessionId(session_id)
        }

        if (usecase) {
            fetchActiveSession(usecase.id)
        }
    }, [usecase])

    return iserrorPresent ? (
        <div className="TacticalView" data-test-id="tactical-view-container">
            <div className="ErrorContainer" data-test-id="error-container">
                <span className="ErrorText" data-test-id="error-text">
                    🦫 {errorMessage} 🪵
                </span>
            </div>
        </div>
    ) : (
        <>
            <div className="TacticalView" data-test-id="tactical-view-container">
                {showLeftAssetsDrawer && (
                    <Button
                        className={drawersState.assetsButtonStyle}
                        size="small"
                        variant="contained"
                        onClick={(e) => toggleAssetsDrawer(e)}
                    >
                        {renderAssetsDrawerIcon()}
                    </Button>
                )}
                <Button
                    className={drawersState.detectionsButtonStyle}
                    size="small"
                    variant="contained"
                    onClick={(e) => toggleDetectionsDrawer(e)}
                >
                    {renderDetectionsDrawerIcon()}
                </Button>
                <TacticalMap
                    selectedFromList={selectedFromList}
                    detectionSelectedFromList={detectionSelectedFromList}
                    useCaseData={usecase}
                    activeSessionId={activeSessionId!}
                />
            </div>
            {showTacticalInformation && (
                <Drawer
                    PaperProps={{ style: { height: 'calc(100vh - 3rem)', width: '27rem', top: '3.5rem' } }}
                    BackdropProps={{ invisible: true }}
                    anchor="left"
                    open={drawersState.assetsDrawerState}
                    variant="persistent"
                >
                    <TacticalInformation setSelectedFromList={setSelectedFromList} useCaseData={usecase} />
                    <TacticalVideo />
                    <TacticalTelemetry />
                </Drawer>
            )}

            <Drawer
                PaperProps={{ style: { height: 'calc(100vh - 3rem)', width: '18rem', top: '3.5rem' } }}
                BackdropProps={{ invisible: true }}
                anchor="right"
                open={drawersState.detectionsDrawerState}
                variant="persistent"
            >
                <TacticalDetection setDetectionSelectedFromList={setDetectionSelectedFromList} activeSessionId={activeSessionId} />
            </Drawer>
        </>
    )
}

export default TacticalView
